import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { linkedAccountSignup } from "../../store/actions/tenantAction";
import { SHOW_SNACKBAR } from "../../utils/types";
import { useTranslation } from "react-i18next";
import { toTitleCase } from "../../utils/helper";

function MessengerIntegration({ setIsShow, onIntegrated, metaType }) {
    const { t } = useTranslation();
    let dispatch = useDispatch();
    const tenantReducer = useSelector((state) => state.tenantReducer);
    const globalReducer = useSelector((state) => state.globalReducer);
    const metaTypeTitleCase = toTitleCase(metaType);

    useEffect(() => {
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    const handleMessage = (event) => {
        console.log("Received message:", event);
        if (event?.data?.type === 'meta_code') {
            dispatch(
                linkedAccountSignup(
                    {
                        code: event.data.code,
                        accessToken: event.data.access_token,
                        accountType: "MESSENGER",
                        bspId: tenantReducer.tenantDetails?.bsp?.id,
                        tenantId: tenantReducer.tenantDetails?.id,
                        tenantWabaId: globalReducer.waba?.id,
                    },
                    (r) => {
                        dispatch({
                            type: SHOW_SNACKBAR,
                            payload: {
                                type: "success",
                                message: "Instagram Connected Successfully.",
                                open: true,
                            },
                        });
                        setIsShow(false);
                        onIntegrated(r);
                    }
                )
            );
        }
    }

    const continueWithClick = () => {
        const popup = window.open(tenantReducer.tenantDetails?.bsp?.config?.messengerSignUpUrl, 'popup', 'width=600,height=400');
        if (popup) {
            popup.focus();
        }
    };

    return (
        <div className="bg-white max-h-[550px] overflow-auto">
            <form
                className="pt-2 pr-4 pl-4"
                onSubmit={(e) => {
                    e.preventDefault();
                }}
            >
                <div>
                    <div className="text-[14px] min-h-[200px]">
                        <label className="font-semibold text-[16px]">
                            {t('Connect ') + metaTypeTitleCase}
                        </label>
                        {metaType?.toLowerCase() === "messenger" &&
                            <div className="text-gray-500">
                                <p className="mt-2 text-[13px]">
                                    {t('To integrate Messenger with iOmnihub, please connect your Facebook Business Manager account')}
                                </p>
                                <ul className="mt-2 text-[13px] list-disc ml-7">
                                    <li>
                                        {t("If you're already using Messenger with iOmnihub, you will need to disconnect it from Messenger first.")}
                                    </li>
                                    <li className="mt-2">
                                        {t("If you don't want to lose any data, use our plugin to backup your Messenger chat histories.")}
                                    </li>
                                </ul>
                            </div>}
                        <div className="flex w-fit py-2 items-center px-4 bg-theme rounded-md text-white font-medium text-[16px] gap-2 mt-3">
                            <div>
                                <i className="fa-brands fa-facebook"></i>
                            </div>
                            <button
                                type="button"
                                className="text-[14px] transition-all ease-in-out rounded cursor-pointer"
                                onClick={continueWithClick}
                            >
                                {t('Connect ') + metaTypeTitleCase}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default MessengerIntegration;
